import { useForm } from "react-hook-form";
import { ScaleLoader } from "react-spinners";

const INPUT_BASE =
  "w-full h-[44px] px-3 bg-shade-50 border rounded-ns text-[15px] text-ink outline-none transition-colors duration-200 placeholder-shade-900";
const INPUT_OK =
  "border-rule-strong focus:border-accent focus:shadow-[0_0_0_3px_rgba(123,94,167,0.12)]";
const INPUT_ERR = "border-danger";

const ResetPassword = ({ onSubmit, loading }) => {
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();

  return (
    <>
      <div className="mb-5">
        <h2 className="text-[20px] font-bold text-ink mb-1">Forgot your password?</h2>
        <p className="text-xs text-muted">
          Enter your email and we'll send you a reset code.
        </p>
      </div>

      <form onSubmit={handleSubmit(onSubmit)} noValidate>
        <div className="mb-5">
          <label
            htmlFor="email"
            className="block text-[12px] font-medium text-muted mb-[5px]"
          >
            Email Address <span className="text-danger">*</span>
          </label>
          <input
            id="email"
            type="email"
            {...register("email", {
              required: "Email is required",
              pattern: {
                value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
                message: "Invalid email format",
              },
            })}
            placeholder="Enter your email"
            aria-describedby={errors.email ? "email-error" : undefined}
            className={`${INPUT_BASE} ${errors.email ? INPUT_ERR : INPUT_OK}`}
          />
          {errors.email && (
            <p id="email-error" role="alert" className="text-danger text-[11px] mt-1">
              {errors.email.message}
            </p>
          )}
        </div>

        <button
          type="submit"
          disabled={loading}
          aria-busy={loading}
          className="w-full h-12 rounded-ns bg-accent text-white text-[15px] font-bold relative border border-rule-strong  transition-all duration-200 disabled:cursor-not-allowed disabled:opacity-70"
        >
          <span className={loading ? "opacity-0" : "opacity-100"}>Send reset code →</span>
          {loading && (
            <ScaleLoader
              loading
              height={16}
              color="white"
              className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2"
            />
          )}
        </button>

        <p className="mt-4 text-center text-[13px] text-muted">
          Remember it?{" "}
          <a href="/login" className="text-accent font-semibold hover:underline">
            Back to login
          </a>
        </p>
      </form>
    </>
  );
};

export default ResetPassword;
